import React from "react";
import CategoriasHome from "./components/CategoriaHomeItem";
import BannersHome from "./components/BannersHome";
import BuscaProdutos from "./components/BuscaProdutos";
import SeletorLoja from "./components/SeletorLoja";
import GrupoProdutos from "./components/GrupoProdutos";
import GrupoConteudos from "./components/GrupoConteudos";
import Rodape from "./components/Rodape";
import ProdutoModel from "./model/ProdutoModel";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ConteudoModel from "./model/ConteudoModel";
import MockData from "./model/MockData";
import CategoriaModel from "./model/CategoriaModel";
import AppState from "./model/AppState";
import C5CategoriaDAO from "./dataAccess/C5/C5CategoriaDAO";
import LojaModel from "./model/LojaModel";
import WPListasDAO from "./dataAccess/WP/WPListasDAO";
import BannerModel from "./model/BannerModel";
import ObaPromocaoDAO from "./dataAccess/Oba/ObaPromocaoDAO";
import LogUtil from "./util/LogUtil";
import UsuarioModel from "./model/UsuarioModel";
import Carregando from "./components/Carregando";
import NavegadorUtil from "./util/NavegadorUtil";

import { ReactComponent as ImagemInspirese } from "./assets/images/inspirese.svg";
import { ReactComponent as ImagemOfertas } from "./assets/images/ofertas.svg";
import { RouteComponentProps, Link } from "react-router-dom";
import ProxyCacheDAO from "./dataAccess/Proxy/ProxyCacheDados";
import ModalAlertaHome from "./components/ModalAlertaHome";
import ProxyPromocaoDAO from "./dataAccess/Proxy/ProxyPromocaoDAO";
import ObaPromocaoModel, { ObaTipoPromocaoEnum } from "./model/ObaPromocaoModel";

interface IHomeProps extends RouteComponentProps {}

type HomeState = {
  categorias: CategoriaModel[];
  listas: ConteudoModel[];
  receitas: ConteudoModel[];
  dicas: ConteudoModel[];
  ofertas: ProdutoModel[];
  bemQuerer: ProdutoModel[];
  compreNovamente: ProdutoModel[];
  promocoesFF: ProdutoModel[];
  banners: BannerModel[];
  categoriaImagens: CategoriaModel[];
  carregouProdutos: boolean;
  carregouRequests: boolean;
  modalAlertaVisivel: boolean;
  concluido: boolean;
};

class Home extends React.Component<IHomeProps, HomeState> {
  constructor(props: IHomeProps) {
    super(props);

    this.fecharModalAlertaHome = this.fecharModalAlertaHome.bind(this);

    this.state = {
      ofertas: [],
      bemQuerer: [],
      categorias: [],
      listas: [],
      dicas: [],
      receitas: [],
      banners: [],
      categoriaImagens: [],
      compreNovamente: [],
      promocoesFF: [],
      carregouProdutos: false,
      carregouRequests: false,
      modalAlertaVisivel: true,
      concluido: false,
    };
  }

  async componentDidMount(): Promise<void> {
    LogUtil.logPage("Home");
    let allProms: any = [];

    this.setState({ carregouProdutos: false, carregouRequests: false }, () => {
      AppState.setMockData(false);
      if (!AppState.getMockData()) {
        allProms.push(
          C5CategoriaDAO.getInstance()
            .getPrimeiroNivel()
            .then((cats: CategoriaModel[]) => {
              this.setState({ categorias: cats });
            })
        );
  
        const loja: LojaModel | null = AppState.getLojaSelecionada();
  
        if (loja) {
          ProxyPromocaoDAO.getInstance().getPromocoes(loja).then(async listaPromocoesFF => {
            let promos: any = [];
            for (const promo of listaPromocoesFF) {
              if (promo.de <= new Date() && promo.ate >= new Date()) {
                if (promo.lojas.some(l => l.lojaId === loja.lojaId)) {
                  // eslint-disable-next-line no-loop-func
                  ProxyPromocaoDAO.getInstance().getProdutos(loja, promo.id).then(promoProdutos => {
                    if (promoProdutos) {
                      for(const prod of promoProdutos) {
                        prod.ff = true;
                        const cleanPromo = JSON.parse(JSON.stringify(promo)) as ObaPromocaoModel;
                        cleanPromo.produtos = [];
              
                        prod.promo = cleanPromo;
        
                        if (prod.unidade === "GR") {
                          prod.fatorMultiplicacao = 200;
                        }
                        if (cleanPromo.tipo === ObaTipoPromocaoEnum.COMPRE_X_PAGUE_Y) {
                          prod.nome += ` - Compre ${promo.compre}, pague ${promo.pague}`;
                        }
                      }
                      promos = promos.concat(promoProdutos);
    
                      if (promos.length > 10) {
                        this.setState({ promocoesFF: promos });
                      }
                    }
                  });
                }
              }
            }
    
            if (promos.length > 0) {
              LogUtil.log(JSON.stringify({ promos, listaPromocoesFF }));
              this.setState({ promocoesFF: promos });
            }
          });
          
          ProxyCacheDAO.getInstance().getLojaCache(loja)
            .then(produtosCache => {
              if (produtosCache && produtosCache.loja && produtosCache.loja.lojaId.length > 0) {
                const { ofertas, bemQuerer } = produtosCache;
                
                AppState.setProdutoBemQuerer(bemQuerer);
      
                this.setState({
                  ofertas: ofertas.length < 10 ? ofertas : ofertas.slice(0, 10),
                  bemQuerer:
                    bemQuerer.length < 10 ? bemQuerer : bemQuerer.slice(0, 10),
                  carregouProdutos: true
                });
              }
            })
            .catch((ex) => {
              allProms.push(
                ObaPromocaoDAO.getInstance()
                  .getPromocao(loja)
                  .then(async (r: any) => {
                    let todasOfertas: ProdutoModel[] = [];
                    let todasBemQuerer: ProdutoModel[] = [];
    
                    r.map((item: any) => {
                      item.then((i: any) => {
                        if (Array.isArray(i) && i.length > 0) {
                          todasOfertas = todasOfertas.concat(
                            i.filter((p: any) => p && p.tipoPromocao === "P")
                          );
                          todasBemQuerer = todasBemQuerer.concat(
                            i.filter((p: any) => p && p.tipoPromocao === "C")
                          );
                        }
                      });
                      return item;
                    });
      
                    Promise.all(r).then(async () => {
                      AppState.setProdutoBemQuerer(todasBemQuerer);
      
                      const ofertas: ProdutoModel[] = todasOfertas.sort((a, b) => {
                        return a.precoOriginal - a.precoDesconto >
                          b.precoOriginal - b.precoDesconto ? -1 : 0;
                      });
      
                      const bemQuerer: ProdutoModel[] = todasBemQuerer.sort(
                        (a, b) => {
                          return a.precoOriginal - a.precoDesconto >
                            b.precoOriginal - b.precoDesconto ? -1 : 0;
                        }
                      );
      
                      ProxyCacheDAO.getInstance().postLojaCache({
                        loja,
                        bemQuerer,
                        ofertas,
                      });
      
                      this.setState({
                        ofertas: ofertas.length < 10 ? ofertas : ofertas.slice(0, 10),
                        bemQuerer:
                          bemQuerer.length < 10 ? bemQuerer : bemQuerer.slice(0, 10),
                        carregouProdutos: true
                      });
                    });
                  }).catch((ex) => {
                    this.setState({ carregouProdutos: true });
                    LogUtil.logEvento('ErroCarregarPromocoes', ex);
                  })
              );
          });
  
  
          const logado: UsuarioModel | null = AppState.getUsuarioLogado();
          if (logado) {
            // ProxyCacheDAO.getInstance()
            //   .getCompreNovamente(loja, logado)
            //   .then(async (compreNovamente: any) => {
            //     let todasCN: ProdutoModel[] = [];
            //     compreNovamente.map(async (item: any) => {
            //       item.then((i: any) => {
            //         if (Array.isArray(i) && i.length > 0) {
            //           todasCN = todasCN.concat(i);
            //         }
  
            //         this.setState({
            //           compreNovamente: todasCN,
            //         });
            //       });
            //     });
            //   });
          }
        } else {
          NavegadorUtil.redirect("/lojas", this.props.history);
        }
  
        WPListasDAO.getInstance()
          .getDicas(false)
          .then((dicas: ConteudoModel[]) => {
            this.setState({ dicas });
          });
  
        WPListasDAO.getInstance()
          .getReceitas(false)
          .then((receitas: ConteudoModel[]) => {
            this.setState({ receitas });
          });
  
        WPListasDAO.getInstance()
          .getListas(false)
          .then((listas: ConteudoModel[]) => {
            this.setState({ listas });
          });
  
        allProms.push(
          WPListasDAO.getInstance()
            .getCategorias()
            .then((categoriaImagens: CategoriaModel[]) => {
              this.setState({ categoriaImagens });
            })
        );
  
        WPListasDAO.getInstance()
          .getBanners()
          .then((banners: BannerModel[]) => {
            this.setState({ banners });
          });
  
        Promise.all(allProms)
          .then(() => {
            this.setState({ carregouRequests: true, concluido: true });
          })
          .catch((e) => {
            LogUtil.log(e);
            this.setState({ carregouRequests: true, concluido: true });
            LogUtil.log('concluido');
          });
      } else {
        this.setState({
          ofertas: MockData.getProdutos(),
          bemQuerer: MockData.getProdutos(),
          receitas: MockData.getConteudos(),
          dicas: MockData.getConteudos(),
          listas: MockData.getConteudos(),
          categorias: MockData.getCategorias(),
        });
      }
    });
  }

  fecharModalAlertaHome(): any {
    this.setState({ modalAlertaVisivel: false });
  }

  render(): any {
    const {
      concluido,
      ofertas,
      listas,
      receitas,
      dicas,
      categorias,
      compreNovamente,
      banners,
      categoriaImagens,
      carregouProdutos,
      carregouRequests,
      modalAlertaVisivel,
      promocoesFF,
    } = this.state;
    let { bemQuerer } = this.state;

    bemQuerer = bemQuerer.map((i) => {
      i.bemQuerer = true;
      return i;
    });

    return (
      <section className="home has-footer white-bg">
        <SeletorLoja loja={AppState.getLojaSelecionada()}></SeletorLoja>
        <BuscaProdutos parent={this}></BuscaProdutos>
        {banners && banners.length > 0 && (
          <BannersHome banners={banners}></BannersHome>
        )}
        {categorias && categorias.length > 0 && (
          <CategoriasHome
            items={categorias}
            imagens={categoriaImagens}
          ></CategoriasHome>
        )}
        <ul className="menu">
          <li>
            <Link to={NavegadorUtil.getUrl("/inspirese")}>
              <ImagemInspirese />
            </Link>
          </li>
          <li>
            <Link to={NavegadorUtil.getUrl("/ofertas")}>
              <ImagemOfertas />
            </Link>
          </li>
        </ul>
        {promocoesFF && (
          <GrupoProdutos
            titulo="Green Friday"
            tituloImagem=""
            items={promocoesFF}
            parent={this}
          ></GrupoProdutos>
        )}
        {compreNovamente && (
          <GrupoProdutos
            titulo="Compre novamente"
            tituloImagem=""
            items={compreNovamente}
            parent={this}
          ></GrupoProdutos>
        )}
        {ofertas && (
          <GrupoProdutos
            titulo="Ofertas da semana"
            tituloImagem=""
            items={ofertas}
            parent={this}
          ></GrupoProdutos>
        )}
        {bemQuerer && (
          <GrupoProdutos
            titulo="Cliente bem querer"
            tituloImagem=""
            items={bemQuerer}
            parent={this}
          ></GrupoProdutos>
        )}
        {listas && (
          <GrupoConteudos
            titulo="Listas Sugeridas"
            items={listas}
            parent={this}
          ></GrupoConteudos>
        )}
        {receitas && (
          <GrupoConteudos
            titulo="Receitas"
            items={receitas}
            parent={this}
          ></GrupoConteudos>
        )}
        {dicas && (
          <GrupoConteudos
            titulo="Dicas deliciosas"
            items={dicas}
            parent={this}
          ></GrupoConteudos>
        )}
        <Rodape parent={this} ativo="Home"></Rodape>
        <Carregando exibir={!(carregouProdutos && carregouRequests)} concluido={concluido} />
        <ModalAlertaHome
          fechar={this.fecharModalAlertaHome}
          visivel={modalAlertaVisivel}
        />
      </section>
    );
  }
}

export default Home;
